'use client';

import { createTheme } from '@nextui-org/react';

// 2. Call `createTheme` and pass your custom values
export const klicTheme = createTheme({
  type: 'dark',
  theme: {
    colors: {
      // brand colors
      background: '#0B121D',
      text: '#fff',
      // you can also create your own color
      // primary: 'var(--blue-500)',
      primary: 'var(--grey-500)',
      error: 'var(--error-color)',
      disabled: 'var(--grey-500)',
      // ...  more colors
    },
    space: {},
    fonts: {},
  },
});
